(function($){

  Shopify.theme.sizeChart = {

    init($section) {

      this.section = $section;

      this.dataDiv = $section.find("#size_chart_data_container");

      this.filterDiv = $section.find("#size_chart_head_wrap");

      this.unitDefault = "inches";

      this.hasNum= '';

  		this.language= 'English';

  		this.mainTitlePrefix= 'Sizechart Preview';

  		this.onlineExclusiveText= '* Blue highlight indicates online exclusive size.';

  		this.onlineExclusiveTextFR= '* offert uniquement en ligne.';

  		this.safariFix= 'false';

  		this.selectClass= '.categorySelect';

  		this.tableClassName= '';

  		this.unitDefault= 'inches';

  		this.unitName= ['INCHES', 'CENTIMETERS'];

      this.loadData().then(function(data){

        this.data = data;

        this.initDepartmentDropDown();

      }.bind(this))

    },

    loadData(){

      return new Promise(function(resolve, reject){

        let src = this.section.data('src');

        $.getJSON(src).done(function(data) {

          resolve(data)

        })

        .fail(function() {

          reject("Enable to load the chart data");

        })

      }.bind(this))

    },

    initDepartmentDropDown(){

      let options = Object.keys(this.data).map(function (n){

        return "<option value='"+n+"'>"+this.data[n].label+"</option>";

      }.bind(this))

      this.departementSelector = $("<select />").html(options.join(""));

      this.filterDiv.append(this.departementSelector);

      this.departementSelector.on("change",function(){

        this.updateCategoriesDropDown(this.departementSelector.val());

      }.bind(this)).trigger("change");

    },

    updateCategoriesDropDown(departement){

      let options = this.data[departement].categories.map(function(category){

        return "<option value='"+category.key+"'>"+category.label+"</option>";

      });

      if(!this.categorySelector){

        this.categorySelector = $("<select />");

        this.categorySelector.html(options.join(""));

        this.filterDiv.append(this.categorySelector);

        this.categorySelector.off("change").on("change",function(){

          this.buildContent();

        }.bind(this)).trigger("change");

      }else{

        this.categorySelector.html(options.join("")).trigger("change");

      }

    },

    buildContent(){

      let departement = this.departementSelector.val(),

      category = this.categorySelector.val();

      if(departement && category){

         let selectedCategory = this.data[departement].categories.find(function(n){

           if(n.key === category){

             return n;

           }

         });

        this.sections = selectedCategory.sections;

        this.buildChartFromData();

      }

    },

    buildChartFromData(){

      if (this.sections) {

        this.dataDiv.html('');

        for(var i=0; i < this.sections.length; i++) {

          var sectionName = this.sections[i].section;

          var sectionClass = this.sections[i].elementClass;

          if (sectionName !== 'BR SHORTS') {

            this.dataDiv.append('<h2 class="heading-c meta-section">' + sectionName + '</h2>');

          } else {

            this.dataDiv.append('<h2 class="heading-c meta-section">SIZE CHARTS</h2>');

          }

          this.dataDiv.append('<div class="' + sectionClass + ' chartSection"></div>');

          if (sectionName === 'SIZE CHARTS' || sectionName === 'TABLEAUX DES TAILLES ET POINTURES') {

            this.chartHeader(sectionClass);

            this.sizeChartTables(sectionClass, i);

          } else if (sectionName === 'MEASURING TIPS' || sectionName === 'COMMENT MESURER') {

            this.buildMeasuringTips(this.dataDiv, sectionClass, i);

          } else if (sectionName === 'FIT GUIDES' || sectionName === 'GUIDE DE COUPE') {

            this.buildFitGuides(this.dataDiv, sectionClass, i);

          } else if (sectionName === 'SHOE SIZES' || sectionName === 'TAILLES DE CHAUSSURES') {

            this.buildShoeChart(this.dataDiv, sectionClass, i);

          } else if (sectionName === 'AVAILABILITY' || sectionName === 'DISPONIBILITÉ') {

            this.buildAvailabilityGuide(this.dataDiv, sectionClass, i);

          } else if (sectionName === 'BR SHORTS') {

            this.chartHeader(sectionClass);

            this.sizeChartTables(sectionClass, i);

          }

        }

      }

    },

    chartHeader(sectionClass) {

      var section = jQuery("." + sectionClass);

      // build inches/cm toggle

      section.append('<div class="measurement_toggle"></div>');

      if (this.unitDefault == "inches") {

        section.append('<div class="measurement_single">All sizes displayed in inches</div>');

        jQuery(".measurement_toggle").append('<div class="inches_btn heading-c g-1-2 active">' + this.unitName[0] + '</div>');

        jQuery(".measurement_toggle").append('<div class="cm_btn g-1-2 heading-c">' + this.unitName[1] + '</div>');

      } else {

        jQuery(".measurement_toggle").append('<div class="inches_btn heading-c g-1-2">' + this.unitName[0] + '</div>');

        jQuery(".measurement_toggle").append('<div class="cm_btn g-1-2 heading-c active">' + this.unitName[1] + '</div>');

      }



      //build online exclusive highlight banner

      section.append('<div class="online_highlight heading-d" style="display: none;"><div class="online_exclusive g-1-2">' + (this.language === 'English' ? this.onlineExclusiveText : this.onlineExclusiveTextFR) + '</div></div>');



      // add chart containter

      section.append('<div class="size_chart_accordion"></div>');

    },

    sizeChartTables(sectionClass, i) {

      var tables = this.sections[i].tables;

      if (tables !== undefined) {

        for(var j = 0; j < tables.length; j++) {

          var table = tables[j].table;

          var accordionWrap = jQuery("." + sectionClass + " .size_chart_accordion");

          this.tableClassName = tables[j].elementClass;

          var t = this.tableClassName;

          this.tableWrap = t + '_data';



          /* populates the table title and creates accordion containers */

          accordionWrap.append('<h3 class="' + t + '_heading heading-d">' + table + '</h3>');

          accordionWrap.append('<div class="' + t + ' chartTable body-a" data-table_name="' + table + '" data-table_class="' + t + '" data-content_count=""></div>');



          /* assign this.tableClass as tableClassName jQuery object */

          this.tableClass = jQuery("." + t);

          /* static table head column (for large breakpoint) */

          this.tableClass.append('<div class="' + t + 'Head tableHead"></div>');

          /* testing out if we need the "rowMaster0" class, the data-row="rowWrap0" and the &nbsp; in cell div */

          jQuery("." + t + "Head").append('<div class="row_wrap alpha"><div class="cell"></div></div>');

          /* scrollable table data */

          this.tableClass.append('<div class="' + this.tableWrap  + '_wrap tableWrap"><div class="' + this.tableWrap  + ' dataWrap"></div></div>');



          /* begin populating table */

          this.addTableContent(tables,j);

          // set legends for table

          this.addChartLegends(tables,j);



          // set units for display

          this.displayChartUnits();



          // set jquery ui accordion script

          setTimeout(function(){

            this.setAccordionScript('.size_chart_accordion');

          }.bind(this), 300);

        }

      }

    },

    addTableContent(tables, j) {

      var sizes = tables[j].tableContent;

      var contentCount = tables[j].tableContent.length;

      var alphaSegment = sizes[0].segmentContent[0];

      var numSegment = sizes[0].segmentContent[1];

      var t = this.tableClassName;



      // Loop through each segment

      for(var k = 0; k < contentCount; k++) {

        var segName = sizes[k].segment;

        // if SIZE segment

        if (k === 0) {

          jQuery("." + t).data('content_count', contentCount);

          this.tableClass.addClass('small-data');



          // add tableHead column

          var tHead = jQuery("." + t + "Head");

          // get alpha name

          var alphaName = alphaSegment.name;

          // check if alphaName is empty and replace with num space

          if (alphaName === "") {

            alphaName = "&nbsp;";

          }

          tHead.html('<div class="cell-row row-master master-row" data-duplicate="master"><div data-row="' + t + '_wrap_master" class="cell" ><div class="cellText">' + alphaName + '</div></div></div>');



          // add mobile scroll chart

          jQuery("." + this.tableWrap).append('<div class="' + t + '_scroll_content flexchart data-table-body scrollWide' + contentCount + '"></div>');

          var tBody = jQuery("." + t + " .data-table-body");

          var numName = numSegment.name;

          // check if numName is empty and replace with num space

          if (numName === "") {

            numName = "&nbsp;";

          }

          tBody.append('<div class="cell-row-wrap row-wrap-master" data-duplicate="master"><div class="cell-row data-row-master"><div class="cell num_unit"><div class="cellText">' + numName + '</div></div></div></div>');



          // loops through segmentContent to get number of cells

          for(var l = 0; l < sizes[k].segmentContent.length; l++) {

            var segRow = sizes[k].segmentContent[l].cells;

            var segLength = sizes[k].segmentContent[l].cellCount;

            if (segLength !== segRow.length) {

              console.info(this.errorRowCountMismatch + ' - ' + alphaSegment.row);

            }



            // loop through alpha cells

            if (l == 0) {

              for (var m = 0; m<segLength; m++) {

                var cell_container = segRow[m];

                var cell_dup = cell_container.duplicate;

                var cell_size = cell_container.size;

                var cell_data = cell_container.cell;



                // get cell_size class

                if (cell_size === 'singleCol') {

                  var size_class = 'single-row';

                } else if (cell_size === 'doubleCol') {

                  var size_class = 'double-row';

                } else if (cell_size === 'tripleCol') {

                  var size_class = 'triple-row';

                } else {

                  var size_class = 'oversize-row';

                }

                // if duplicate == m, add cell

                if (cell_dup == m) {

                  // insert cell

                  tHead.append('<div class="cell-row row-' + m +' master-row" data-duplicate="' + cell_dup + '"><div class="cell alpha_unit ' + size_class + '"><div class="cellText">' + cell_data + '</div></div>');

                  // insert data cell wrap into table body

                  tBody.append('<div class="cell-row-wrap row-wrap-' + m + '" data-duplicate="' + cell_dup + '"></div>')

                }

              }



            } else if (l == 1) {

              var numEmpty = sizes[k].segmentContent[l].empty;

              // loop through num cells

              for (var m = 0; m<segLength; m++) {

                var cell_container = segRow[m];

                var cell_pos = cell_container.position;

                var cell_exclusive = cell_container.exclusive;

                if (cell_exclusive === 'true') {

                  var exclusive_class = 'online_exclusive';

                  jQuery('.online_highlight').css({'display':'block'});

                } else {

                  var exclusive_class = '';

                }

                var cell_data = cell_container.cell;



                jQuery("." + t + " .row-wrap-" + cell_pos).append('<div class="cell-row data-row-' + m + '"><div class="cell num_unit ' + exclusive_class + '"><div class="cellText">' + cell_data + '</div></div></div>')

              }

              // if all cells are empty, hide num rows

              if (numEmpty === true) {

                this.hideNumUnits(t, contentCount);

              }

            }

          }

        } else {

          // loop through remaining segments

          for(var l = 0; l < sizes[k].segmentContent.length; l++) {

            var seg = sizes[k].segmentContent[l];

            var segRow = seg.cells;

            var segLength = seg.cellCount;

            var measurement = seg.row;

            if (segLength !== segRow.length) {

              console.info(this.errorRowCountMismatch + ' - ' + alphaSegment.row);

            }



            // add segment name to master row

            jQuery("." + t + " .data-row-master").append('<div class="cell ' + measurement + '_unit"><div class="cellText">' + segName + '</div></div>');





            // loop through cells

            for (var m = 0; m<segLength; m++) {

              var cell_container = segRow[m];

              var cell_pos = cell_container.position;

              var cell_exclusive = cell_container.exclusive;

              if (cell_exclusive === 'true') {

                var exclusive_class = 'online_exclusive';

                jQuery('.online_highlight').css({'display':'block'});

              } else {

                var exclusive_class = '';

              }

              var cell_data = cell_container.cell;



              jQuery("." + t + " .data-row-" + m).append('<div class="cell ' + measurement +'_unit ' + exclusive_class + '"><div class="cellText">' + cell_data + '</div></div>');

            }

          }

        }

      }

      this.setCellHeight(t);

      this.setIscroll(contentCount, t);

    },

    hideNumUnits(table, colCount) {

      setTimeout(function() {

        /* need to look into this one */

        var t = jQuery('.' + table + ' .data-table-body');

        var numCol = colCount - 1;

        t.removeClass('scrollWide' + colCount);

        t.addClass('scrollWide' + numCol);

        var numCells = jQuery('.' + table + ' .num_unit');

        numCells.hide();

      }, 500);

    },

    setCellHeight(table) {

      // loop through cell-rows in head

      var rows = jQuery('.' + table + ' .master-row');

      rows.each( function (i) {

        var row = jQuery(this);

        var row_data = row.data('duplicate');

        var row_height = row.height();

        var partner = jQuery('.' + table + ' .row-wrap-' + row_data);

        var partner_height = partner.height();

        if (row_height < partner_height) {

          row.css({'height': partner_height});

          partner.css({'height': partner_height});

        } else if (row_height > partner_height) {

          partner.css({'height': row_height});

          row.css({'height': row_height});

        }

      });

    },

    setIscroll(contentCount,tableClassName) {

      var scrollTable = "." + tableClassName + "_scroll_content";

      var scrollWidth = "scrollWide" + contentCount;

      var scrollParent = "." + tableClassName + "_data";

      jQuery(scrollParent).addClass('scrollChart');

      jQuery(scrollTable).addClass(scrollWidth);

      if (contentCount > 3) {

        new IScroll(scrollParent, {

          mousewheel: false,

          scrollbars: true,

          eventPassthrough: true,

          scrollX: true,

          scrollY: false,

          interactiveScrollbars: true

        });

      }

    },

    addChartLegends(tables,j) {

      var legends = tables[j].legends;

      if (legends != undefined) {

        this.tableClass.append('<div class="' + this.tableClassName + '_legend table_legend"></div>');

        var legendWrap = jQuery('.' + this.tableClassName + '_legend');

        for(var n=0; n < legends.length; n++) {

          var legendTitle = legends[n].title;

          var legendDesc = legends[n].desc;

          if (legendTitle !== undefined && legendTitle !== null) {

            legendWrap.append('<p class="legend_desc body-a"><strong>' + legendTitle + '</strong><br/>' + legendDesc + '</p>');

          } else {

            legendWrap.append('<p class="legend_desc body-a">' + legendDesc + '</p>');

          }



        }

      }

    },

    displayChartUnits() {

      var cm = jQuery('.cm_unit');

      var cm_btn = jQuery('.cm_btn');

      if (this.language == "French") {

        var inch = jQuery('.pouces_unit');

        var inches_btn = jQuery('.inches_btn');

      } else {

        var inch = jQuery('.inches_unit');

        var inches_btn = jQuery('.inches_btn');

      }



      if (cm.length !== 0) {

        if (this.unitDefault === 'inches') {

          cm.addClass('chartHide');

        } else {

          inch.addClass('chartHide');

        }

        inches_btn.on('click', function(){

          inches_btn.addClass('active');

          cm_btn.removeClass('active');

          inch.removeClass('chartHide');

          cm.addClass('chartHide');

        });

        cm_btn.on('click', function(){

          cm_btn.addClass('active');

          inches_btn.removeClass('active');

          cm.removeClass('chartHide');

          inch.addClass('chartHide');

        });

      } else {

        jQuery('.measurement_toggle').hide();

        jQuery('.measurement_single').show();

      }

    },

    buildMeasuringTips(dataContainer, sectionClass, i) {

      var header = this.sections[i].header;

      var subhead = this.sections[i].subhead;

      var sectionImage = this.sections[i].image_url;

      var sectionHDImage = this.sections[i].hd_image_url;

      var contents = this.sections[i].contents;

      var section = jQuery("." + sectionClass);

      section.data('image', sectionImage);

      section.data('hd_image', sectionHDImage);

      section.append('<h4 class="section_header heading-d">' + header + '</h4>');

      section.append('<p class="section_subhead body-a">' + subhead + '</p>');

      if (contents !== undefined) {

        section.append('<div class="section_content_wrap grid-root"></div>');

        var contentWrap = jQuery("." + sectionClass + " .section_content_wrap");

        contentWrap.append('<div class="section_item_wrap g-1-1"></div>');

        var itemWrap = jQuery("." + sectionClass + " .section_item_wrap");

        for(var j=0; j < contents.length; j++) {

          var contentTitle = contents[j].title;

          var contentDesc = contents[j].desc;

          itemWrap.append('<div class="section_item item' + j + '"></div>');

          var item = jQuery(".item" + j);

          item.append('<h4 class="item_title heading-d">' + contentTitle + '</h4>');

          item.append('<p class="item_desc body-a">' + contentDesc + '</p>');

        }



        if (sectionImage != "") {

          itemWrap.addClass('g-lg-1-2');

          if (sectionHDImage != "" && sectionHDImage != "undefined" && sectionHDImage != undefined) {

            contentWrap.append('<div class="section_image_wrap g-lg-1-2"><img src="' + assetPath + 'images/' + sectionImage + '" srcset="' + assetPath + 'images/' + sectionImage +' 1x, ' + assetPath + 'images/' + sectionHDImage +' 2x"></div>');

          } else {

            contentWrap.append('<div class="section_image_wrap g-lg-1-2"><img src="' + assetPath + 'images/' + sectionImage + '"></div>');

          }

        }

      }

    },

    setAccordionScript(accordion) {

      var __this = this;

      accordion = $(accordion);

      accordion.find('h3.regular_chart_table_heading').first().addClass('show');

      if(accordion.find('.chartTable').length > 1){

        accordion.find('.chartTable').slice(1).hide();

      }

      accordion.off('click').on('click','h3',function(){

        if(!$(this).hasClass('show')){

          accordion.find('h3.show').removeClass('show');

          accordion.find('div.chartTable').slideUp();

          $(this).addClass('show');

          $(this).next('div').slideDown();

          __this.dataDiv.animate({scrollTop: 110 })

        }else{

          $(this).removeClass('show');

          $(this).next('div').slideUp();

        }

      })

    }

  }
  $('.js-unit-controller').click(function() {
    var $this = $(this),
        unit = $this.data('unit'),
        cell = $(`.sizechart .column .cell .${unit}`);

    $this.addClass('active').siblings().removeClass('active');
    cell.parent().siblings().addClass('hide')
    cell.parent().removeClass('hide');
  })
  $('.js-sc-controller').click(function() {
    var $this = $(this),
        content = $this.data('content'),
        toggleContent = $(`.js-sc-toggle-content[data-content="${content}"]`);

    $this.toggleClass('active').siblings().removeClass('active');
    toggleContent.toggleClass('active').siblings().removeClass('active');
    if(toggleContent.find('.chart-container .chart.active').length > 0) {
      setColumnheight(toggleContent.find('.chart-container .chart.active').find('.sizechart').get(0));
    }
  })
  $('.js-chart-controller').click(function() {
    var $this = $(this),
        chart = $this.data('chart');

    $this.addClass('active').siblings().removeClass('active');
    $(`.chart-container .chart.${chart}`).addClass('active').siblings().removeClass('active');
    setColumnheight($(`.chart-container .chart.${chart}`).find('.sizechart').get(0))
  })
  
  $('#m_size_chart').click(function(e) {
    e.preventDefault();
    toggleSizeChartModal();
  })
  
  $('#size_chart_modal .sc-close, #size_chart_modal .sc-popup-bg').click(function() {
    toggleSizeChartModal();
  })
  
  function toggleSizeChartModal() {
    var s_modal = $('#size_chart_modal');
    
    s_modal.fadeToggle(400, 'swing', function() {
      $('#header-sticky-wrapper, #mobile-header-sticky-wrapper').toggle();
      $('html').toggleClass('scroll-hidden');
      setColumnheight(document.querySelector('.chart.active .sizechart'))
    });
    
  }
  
  function setColumnheight(size_charts) {
    if(NodeList.prototype.isPrototypeOf(size_charts)) {
      size_charts.forEach(chart => {
        var column = chart.querySelector('.main .column'),
            column_height = column.offsetHeight,
            sidebar = chart.querySelector('.headerColumn');
        
        sidebar.style.height = `${column_height}px`;
      })
    }else {
      var chart = size_charts;
      var column = chart.querySelector('.main .column'),
          column_height = column.offsetHeight,
          sidebar = chart.querySelector('.headerColumn');
      
      sidebar.style.height = `${column_height}px`;
    }
    
  }
//   window.addEventListener('DOMContentLoaded', e => {
//     var size_charts = document.querySelector('.chart.active .sizechart');

//     setColumnheight(size_charts)
//   })

})(jQuery);

